module.exports = __webpack_public_path__ + "static/media/hwassign.6b69e5f0.png";